module.exports = __webpack_public_path__ + "static/media/cloud1.3ba05f70.svg";